import { useTranslation } from 'react-i18next';
import { Typography } from 'app/components';

export type MissingDefaultKey =
  | 'defaults.missing.section'
  | 'defaults.missing.lei'
  | 'defaults.missing.date'
  | 'defaults.missing.currency'
  | 'defaults.missing.scale'
  | 'defaults.missing.accuracy';

export const MissingDefaultHint = ({ labelKey }: { labelKey: MissingDefaultKey }) => {
  const { t } = useTranslation('tag');

  return (
    <Typography variant="body-7" color="#e07800">
      {t(labelKey)}
    </Typography>
  );
};
